import { getContextHelpers, toObjectKeys } from 'ad-hok-utils'

export type RodeoOrEditViewType = 'rodeo' | 'edit'

interface RodeoOrEditViewTypeContext {
  rodeoOrEditView: RodeoOrEditViewType
}

export const [addRodeoOrEditViewContextProvider, addRodeoOrEditViewContext] =
  getContextHelpers<RodeoOrEditViewTypeContext>(
    toObjectKeys(['rodeoOrEditView'])
  )
